export const mockExerciseData = [
    {
        username: "Jason",
        activity: "Running",
        description: "Enjoyed a brisk jog along the riverbank.",
        duration: 40,
        date: "2022-02-01",
        _id: "656b72316d5daa6449176a"
    },
    {
        username: "Jason",
        activity: "Climbing",
        description: "Tackled a difficult bouldering route.",
        duration: 55,
        date: "2022-06-03",
        _id: "656b3316d5daa6449176a"
    },
    {
        username: "Mark",
        activity: "Football",
        description: "Practiced penalty shots with teammates.",
        duration: 75,
        date: "2023-10-05",
        _id: "65745b316d5daa6449176a"
    },
    {
        username: "Mark",
        activity: "Golf",
        description: "Played a relaxing round at the local course.",
        duration: 90,
        date: "2023-08-07",
        _id: "656b3316d5dhde749176a"
    },
    {
        username: "Amelia",
        activity: "Swimming",
        description: "Completed laps in the pool for cardio.",
        duration: 60,
        date: "2022-04-09",
        _id: "656b3399fnv5daa6449176a"
    },
    {
        username: "Amelia",
        activity: "Yoga",
        description: "Focused on balance and meditation.",
        duration: 50,
        date: "2023-02-11",
        _id: "656b3316d5daa64nc776a"
    },
    {
        username: "Sophia",
        activity: "Basketball",
        description: "Played a competitive game at the community court.",
        duration: 120,
        date: "2023-02-13",
        _id: "656b3358gn5daa6449176a"
    },
    {
        username: "Sophia",
        activity: "Dancing",
        description: "Took a fun dance class with friends.",
        duration: 70,
        date: "2023-12-15",
        _id: "656b3316d5daa47hv9176a"
    },
    {
        username: "Amelia",
        activity: "Running",
        description: "Completed running session.",
        duration: 65,
        date: "2023-01-18",
        _id: "656b3316d5bsb59176a"
    },
    {
        username: "Daniel",
        activity: "Football",
        description: "Practiced football drills.",
        duration: 85,
        date: "2022-11-22",
        _id: "85h6b3316d5daa6449176a"
    },
    {
        username: "Sophia",
        activity: "Climbing",
        description: "Tackled challenging climbing routes.",
        duration: 75,
        date: "2022-10-07",
        _id: "656b3316ncnf7daa6449176a"
    },
    {
        username: "Mark",
        activity: "Basketball",
        description: "Engaged in a competitive basketball match.",
        duration: 110,
        date: "2023-01-12",
        _id: "68rnbf5b3316d5daa6449176a"
    },
    {
        username: "Jason",
        activity: "Swimming",
        description: "Completed laps in the pool.",
        duration: 50,
        date: "2022-11-25",
        _id: "97hr3316d5daa6449176a"
    },
    {
        username: "Sophia",
        activity: "Yoga",
        description: "Focused on relaxing yoga poses.",
        duration: 40,
        date: "2023-01-29",
        _id: "656b756f16d5daa6449176a"
    },
    {
        username: "Amelia",
        activity: "Dancing",
        description: "Took part in a dance workshop.",
        duration: 80,
        date: "2023-06-08",
        _id: "65749b3316d5daa6449176a"
    },
    {
        username: "Daniel",
        activity: "Golf",
        description: "Played a round of golf with friends.",
        duration: 95,
        date: "2023-06-14",
        _id: "0091f3316d5daa6449176a"
    },
    {
        username: "Mark",
        activity: "Running",
        description: "Jogged around the city park.",
        duration: 45,
        date: "2023-03-21",
        _id: "6585hj16d5daa6449176a"
    },
    {
        username: "Jason",
        activity: "Basketball",
        description: "Practiced dribbling and shooting.",
        duration: 60,
        date: "2023-01-10"
    },
    {
        username: "Sophia",
        activity: "Swimming",
        description: "Engaged in a swimming workout.",
        duration: 70,
        date: "2023-11-17",
        _id: "656b3316d5daajjj9176a"
      },
      {
        username: "Mark",
        activity: "Yoga",
        description: "Focused on yoga poses and breathing exercises.",
        duration: 55,
        date: "2022-09-23",
        _id: "656b3316d5daa64491lllw"
      },
      {
        username: "Amelia",
        activity: "Basketball",
        description: "Played basketball with friends.",
        duration: 90,
        date: "2022-09-26",
        _id: "656b3316d5daa649oop176a"
      },
      {
        username: "Daniel",
        activity: "Dancing",
        description: "Took part in a dance competition.",
        duration: 65,
        date: "2023-02-30",
        _id: "656b3316d5dnop2449176a"
      },
      {
        username: "Jason",
        activity: "Golf",
        description: "Enjoyed a round of golf at the country club.",
        duration: 100,
        date: "2023-10-11",
        _id: "677lowb3316d5daa6449176a"
      },
      {
        username: "Sophia",
        activity: "Running",
        description: "Ran a scenic trail through the woods.",
        duration: 55,
        date: "2023-01-19",
        _id: "45t6b3316d5daa6449176a"
      },
      {
        username: "Mark",
        activity: "Swimming",
        description: "Completed a pool workout for endurance.",
        duration: 80,
        date: "2023-01-27",
        _id: "656b68hil6d5daa6449176a"
      },
      {
        username: "Amelia",
        activity: "Climbing",
        description: "Conquered challenging indoor climbing walls.",
        duration: 70,
        date: "2023-01-13",
        _id: "656berm6d5daa6449176a"
      },
      {
        username: "Daniel",
        activity: "Football",
        description: "Participated in a friendly football match.",
        duration: 120,
        date: "2023-01-20",
        _id: "0wrtb3316d5daa6449176a"
      },
      {
        username: "Jason",
        activity: "Dancing",
        description: "Took a dance class to learn new moves.",
        duration: 50,
        date: "2023-01-24",
        _id: "qretb3316d5daa6449176a"
      },
      {
        username: "Sophia",
        activity: "Basketball",
        description: "Practiced layups and three-pointers.",
        duration: 60,
        date: "2023-01-28",
        _id: "656b3tum6d5daa6449176a"
      },
      {
        username: "Mark",
        activity: "Yoga",
        description: "Joined a yoga session for flexibility.",
        duration: 45,
        date: "2023-02-16",
        _id: "656bsed16d5daa6449176a"
      },
      {
        username: "Amelia",
        activity: "Running",
        description: "Jogged in the morning for cardiovascular health.",
        duration: 40,
        date: "2023-04-29",
        _id: "656b3316dtemuaa6449176a"
      },
      {
        username: "Daniel",
        activity: "Climbing",
        description: "Explored outdoor rock climbing routes.",
        duration: 90,
        date: "2023-06-15",
        _id: "65558880b3316d5daa6449176a"
      },
      {
        username: "Jason",
        activity: "Football",
        description: "Played a game of football at the local park.",
        duration: 75,
        date: "2023-08-12",
        _id: "656b331234ghd5daa6449176a"
      }
]